'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------------------------------------- Component
/**
  * UpdateTitle - Updates the page title
  *
  * @example
    <UpdateTitle />
  *
  * @param {string} title - Required. The title of the webpage.
  *
  * @version 0.0.1
  * @todo none
  */
var UpdateTitle = function UpdateTitle(props) {
  return _react2.default.createElement(_reactHelmet2.default, {
    title: props.title
  });
}; // ----------------------------------------------------------------------- Imports


UpdateTitle.propTypes = process.env.NODE_ENV !== "production" ? {
  title: _propTypes2.default.string
} : {};

UpdateTitle.defaultProps = {
  title: 'Webpage'
};

// ----------------------------------------------------------------------- Export
exports.default = UpdateTitle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/seo/lib/UpdateTitle.js
// module id = 461
// module chunks = 168707334958949